module.exports = __webpack_public_path__ + "static/media/feather.493a5578.svg";